import { OrderedAsyncEnumerable } from "../OrderedAsyncEnumerable.js";
export const orderBy = (source, keySelector, comparer) => {
    return OrderedAsyncEnumerable.generate(source, keySelector, true, comparer);
};
